var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-birthday.dbc17f90.png","uri@2x": __webpack_public_path__ + "icon-birthday.9ff60f9b.png","uri@3x": __webpack_public_path__ + "icon-birthday.7ffbca62.png",
    width: 20,
    height: 20
});